import { useMemo } from "react";
import { useEnsAvatar } from "wagmi";
import { normalize } from "viem/ens";
import blockies from "ethereum-blockies";
import { AvatarWithTitle } from "./AvatarWithTitle";
import { truncateAddress } from "../utils/address";
import CopyToClipboardButton from "../../common/CopyToClipboardButton";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function ContributorProfile(_ref) {
  let {
    address,
    ensName
  } = _ref;
  const {
    data: ensAvatar
  } = useEnsAvatar({
    name: ensName ? normalize(ensName) : undefined,
    chainId: 1
  });
  const addressLogo = useMemo(() => {
    return ensAvatar !== null && ensAvatar !== void 0 ? ensAvatar : blockies.create({
      seed: address.toLowerCase()
    }).toDataURL();
  }, [address, ensAvatar]);
  const partialAddress = truncateAddress(address);
  const currentOrigin = window.location.origin;
  return /*#__PURE__*/_jsxs("div", {
    className: "flex flex-row items-center justify-between",
    children: [/*#__PURE__*/_jsx(AvatarWithTitle, {
      avatarSrc: addressLogo,
      title: ensName || partialAddress,
      avatarAlt: "Address Logo",
      dataTestId: {
        title: "contributor-address"
      }
    }), /*#__PURE__*/_jsx("div", {
      className: "flex justify-between items-center",
      children: /*#__PURE__*/_jsx(CopyToClipboardButton, {
        textToCopy: `${currentOrigin}/#/contributors/${address}`,
        iconStyle: "w-3.5 mr-1 mt-1 shadow-sm"
      })
    })]
  });
}